module.exports = __webpack_public_path__ + "img/accordion-icon.cc2fac0c.svg";